export const selectNiveaux = (state) => state.niveau.list;
export const selectSelectedNiveau = (state) => state.niveau.selectedNiveau;
